import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Box, Paper, Stack, useTheme } from "@mui/material";
import { CircleCheck, House } from "lucide-react";
import { Typography, Button } from "@powerdiary/components-library/lib";
import { ROUTES } from "../../routes";
import { useClientPortalConfigContext } from "../../context/ClientPortalConfig.ctx";
import Content from "../Layout/Content";

export const FormSubmissionSuccess = () => {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const navigate = useNavigate();
    const theme = useTheme();

    const isClientPortalActive = !clientPortalConfig?.isClientPortalDisabled;

    useEffect(() => {
        document.title = "Form Submitted - Client Bookings Zanda";
    }, []);

    const navigateHome = () => {
        void navigate(`/clientportal/${clientPortalGuid}/${ROUTES.HOME.urlPath}`);
    };

    return (
        <Content dataTestIdSuffix="form_submission_success" sx={{ alignSelf: "center" }}>
            <Box display="flex" justifyContent="center" padding={3}>
                <Paper>
                    <Stack gap="24px" p="40px" alignItems="center">
                        <CircleCheck
                            size={28}
                            strokeWidth={2}
                            color={theme.palette.primary.main}
                            data-test-id="icon_success"
                            aria-hidden
                        />

                        <Typography
                            variant="heading3"
                            fontSize={22}
                            textAlign="center"
                            data-test-id="text_success_message"
                        >
                            Your form has been submitted successfully
                        </Typography>

                        {isClientPortalActive && (
                            <Button
                                variant="contained"
                                startIcon={<House size={18} strokeWidth={2} aria-hidden />}
                                onClick={navigateHome}
                                data-test-id="button_home"
                            >
                                Home
                            </Button>
                        )}
                    </Stack>
                </Paper>
            </Box>
        </Content>
    );
};
